import { render, staticRenderFns } from "./AscFleetFaultMsgTab2Wrapper.vue?vue&type=template&id=c4e565b4&"
import script from "./AscFleetFaultMsgTab2Wrapper.vue?vue&type=script&lang=js&"
export * from "./AscFleetFaultMsgTab2Wrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscFleetFaultMsgTab2Wrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports